import React from "react";
import ReactMarkdown from "react-markdown";
import { Dialog, Transition } from "@headlessui/react";
import ModalHeader from "./ModalHeader";

interface DocumentViewerModalProps {
  open: boolean;
  title: string;
  content: string;
  onClose: () => void;
}

const DocumentViewerModal: React.FC<DocumentViewerModalProps> = ({
  open,
  title,
  content,
  onClose,
}) => {
  return (
    <Transition appear show={open} as={React.Fragment}>
      <Dialog as="div" className="relative z-[10055]" onClose={onClose}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto z-[10055]">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="eai-card flex w-full max-w-[900px] transform flex-col overflow-hidden transition-all" style={{ maxHeight: "85dvh" }}>
                {/* Shared chrome, so this viewer can't drift from the rest of the modals */}
                <ModalHeader title={title} onClose={onClose} gutterClassName="eai-modal-gutter" />

                {/* Content */}
                <div className="eai-modal-gutter grow overflow-y-auto py-6">
                  <div className="prose prose-zinc max-w-none font-inter">
                    <ReactMarkdown>{content}</ReactMarkdown>
                  </div>
                </div>

                {/* Footer */}
                <div className="eai-modal-gutter flex justify-end border-t border-eai-border pb-5 pt-4">
                  <button type="button" onClick={onClose} className="eai-btn-outline">
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default DocumentViewerModal;
